import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../shared/modal/modal";
import styles from "./delete-report-modal.module.scss";
import { deleteReport } from "../../../../../services/api";
import { fetchReports } from "../../../../../services/reducers/reports-journal";
import { useAppDispatch } from "../../../../../hooks/useAppDispatch";
import rejectIcon from "../../../../../images/error-120.svg";
import Button from "../../../../ui-kit/button/button";

interface DeleteReportModalProps {
  reportId: number;
  onClose: () => void;
  cityName: string;
}

const DeleteReportModal: FC<DeleteReportModalProps> = ({
  reportId,
  onClose,
  cityName,
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleDeleteReport = async () => {
    await deleteReport(reportId);
    dispatch(fetchReports());
    onClose();
  };

  return (
    <Modal
      className={styles.modal}
      closeClass={styles.closeBtn}
      onClose={onClose}
    >
      <div className={styles.modalWrapper}>
        <h2 className={styles.title}>{t("delete-report-modal.title")}</h2>
        <img className={styles.img} src={rejectIcon} alt="Reject" />
        <span className={styles.description}>
          {t("delete-report-modal.description", { cityName })}
        </span>
        <p className={styles.warningText}>{t("delete-report-modal.warning")}</p>
        <div className={styles.groupBtn}>
          <Button
            className={styles.deleteBtn}
            onClick={handleDeleteReport}
            type="primary"
          >
            {t("delete-report-modal.deleteButton")}
          </Button>
          <Button className={styles.cancelBtn} onClick={onClose} type="outline">
            {t("delete-report-modal.cancelButton")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteReportModal;
